import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import MigrationWorkbench from './components/MigrationWorkbench/MigrationWorkbench';


const Routes = () => (
  <div className="main-layout full-width">
    <Route exact path="/migration" render={() => <Redirect to="/migration/sailpoint-migration/getting-started" />} />
    <Route exact path="/migration/sailpoint-migration" render={() => <Redirect to="/migration/sailpoint-migration/getting-started" />} />
    <Route exact path="/migration/oim-migration" render={() => <Redirect to="/migration/oim-migration/getting-started" />} />
    <Route path="/migration/:sourceType/:tab" render={(props) => <MigrationWorkbench {...props} />} />
  </div>
);
export default Routes;